import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mr-4 md:mr-0" }, "Please select your preferred account type below:")
], -1)
const _hoisted_3 = { class: "flex flex-wrap items-center pr-6 mt-6" }
const _hoisted_4 = { class: "w-full md:w-1/2" }
const _hoisted_5 = { class: "flex flex-wrap content-between h-64 p-8 mr-0 border border-gray-300 rounded md:mr-4 bg-play-peach" }
const _hoisted_6 = { class: "text-xl font-bold capitalize" }
const _hoisted_7 = { class: "w-full md:w-1/2" }
const _hoisted_8 = { class: "flex flex-wrap content-between h-64 p-8 ml-0 border border-gray-300 rounded md:ml-4 bg-play-peach" }
const _hoisted_9 = { class: "text-xl font-bold capitalize" }

import { ref } from "vue";
import { useRouter } from "vue-router";

import TitleHeader from "@/components/TitleHeader.vue";
import DefaultButton from "@/components/DefaultButton.vue";

import api from "@/api/api";
import { useUserStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'RoleSelectView',
  setup(__props) {

const router = useRouter();
const userStore = useUserStore();
const isLoading = ref(false);

async function changeRole(role: string) {
  isLoading.value = true;
  await api.users.onboard(role);
  await userStore.fetchUser();
  isLoading.value = false;
  return router.push({ name: "Dashboard" }).then(() => {
    return router.go(0);
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('onboarding')
      }, null, 8, ["title"])
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("professional")), 1),
          _createElementVNode("div", null, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("professional-description")), 1)
          ]),
          _createElementVNode("div", null, [
            _createVNode(DefaultButton, {
              type: "black",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (changeRole('professional'))),
              loading: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("select")), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("parent-carer")), 1),
          _createElementVNode("div", null, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("parent-description")), 1)
          ]),
          _createElementVNode("div", null, [
            _createVNode(DefaultButton, {
              type: "black",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (changeRole('parent'))),
              loading: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("select")), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ])
    ])
  ]))
}
}

})